var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipCardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_629_2948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7342 18.6084H3.2651C2.29193 18.6084 1.5 18.0988 1.5 17.4732V6.24311C1.5 5.6175 2.29193 5.1084 3.2651 5.1084H20.7342C21.7073 5.1084 22.5 5.6175 22.5 6.24311V17.4732C22.5 18.0988 21.7073 18.6084 20.7342 18.6084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7342 18.6084H3.2651C2.29193 18.6084 1.5 18.0988 1.5 17.4732V6.24311C1.5 5.6175 2.29193 5.1084 3.2651 5.1084H20.7342C21.7073 5.1084 22.5 5.6175 22.5 6.24311V17.4732C22.5 18.0988 21.7073 18.6084 20.7342 18.6084ZM12.309 18.2097H20.7342C21.366 18.2097 21.8798 17.8794 21.8798 17.4732V16.2688H18.5505C18.4683 16.2688 18.3897 16.2477 18.3314 16.2103L15.5109 14.3971H12.309V18.2097ZM2.1187 16.2688V17.4732C2.1187 17.8794 2.63331 18.2097 3.2651 18.2097H11.6903V14.3971H8.48908L5.66856 16.2103C5.61033 16.2477 5.53171 16.2688 5.44946 16.2688H2.1187ZM18.6786 15.8701H21.8798V12.057H15.9491V14.1154L18.6786 15.8701ZM2.1187 15.8701H5.3199L8.05017 14.1154V12.057H2.1187V15.8701ZM8.6696 13.9984H15.3289V9.71742H8.6696V13.9984ZM15.9491 11.6593H21.8798V7.84574H18.6786L15.9491 9.60091V11.6593ZM2.1187 11.6593H8.05017V9.60138L5.32063 7.84574H2.1187V11.6593ZM12.309 9.31969H15.5109L18.3314 7.5065C18.3897 7.46906 18.4683 7.44801 18.5505 7.44801H21.8798V6.24311C21.8798 5.83695 21.366 5.50613 20.7342 5.50613H12.309V9.31969ZM8.48835 9.31969H11.6896V5.50613H3.2651C2.63331 5.50613 2.1187 5.83695 2.1187 6.24311V7.44801H5.44874C5.53099 7.44801 5.6096 7.46859 5.66783 7.5065L8.48835 9.31969Z",
    fill: "#1B1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_629_2948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipCardWhite);
export default __webpack_public_path__ + "static/media/ChipCardWhite.0636345c16d9bda3077e57c19b02cd8a.svg";
export { ForwardRef as ReactComponent };